/* eslint-disable jsdoc/require-jsdoc */
import { createAction, props } from '@ngrx/store';
import { QuestionnaireGroup } from '@mona/models';

// Load questionnaire groups
export const loadQuestionnaireGroups = createAction('[ConfigurableQuestionnaires] Load Questionnaire Groups');

export const loadQuestionnaireGroupsSuccess = createAction(
    '[ConfigurableQuestionnaires] Load Questionnaire Groups Success',
    props<{ questionnaireGroups: QuestionnaireGroup[] }>(),
);

export const loadQuestionnaireGroupsFailure = createAction(
    '[ConfigurableQuestionnaires] Load Questionnaire Groups Failure',
    props<{ error?: unknown }>(),
);

// Clear questionnaire groups
export const clearQuestionnaireGroups = createAction('[ConfigurableQuestionnaires] Clear Questionnaire Groups');
